export const TargetTimes = [
  60, // Setup
  90, // Alignment
  180, // Base Shape
  90, // Compression
  30, // Lower Trim
  60, // Upper Surface
  30, // Assemble
  300, // Output
]